import type { ActionCreatorWithPayload } from '@reduxjs/toolkit'

import { useEffect } from 'react'

import {
	type LeftSide,
	leftSideActions
} from '../../redux/reducers/leftSideMenu'
import { useAppDispatch } from './store'

export type LeftSideInput = LeftSide

const createHook =
	<Input>(creator: ActionCreatorWithPayload<Input>) =>
	(input: Input) => {
		const dispatch = useAppDispatch()

		// biome-ignore lint/correctness/useExhaustiveDependencies: false alarm, creator is partial application
		useEffect(() => {
			dispatch(creator(input))
		}, [dispatch, input])
	}

export const useActive = createHook(leftSideActions.setActive)
export const useLeft = createHook(leftSideActions.setLeftSide)
